export default __webpack_public_path__ + "media/src/assets/images/Note-b678f8d43f6c9aea4c42435c9edf0843.svg";